import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Services() {
  const { t } = useTranslation();

  const title = t("home.services_title");
  /*const cta = t("home.cta_contact");*/
  const defaultBlurb = t("home.service_default_blurb");
  const emptyText = t("services.empty");

  const names = t("company.services", { returnObjects: true }) || [];
  const blurbs = t("home.services_blurbs", { returnObjects: true }) || [];
  const logos = t("company.services_logo", { returnObjects: true }) || [];

  const items = names.map((name, i) => ({
    name,
    blurb: blurbs[i] ?? defaultBlurb,
    logo: logos[i] ?? null,
  }));

  return (
    <section className="border-b border-neutral-800">
      <div className="max-w-5xl mx-auto px-4 py-20">
        <div className="flex items-end justify-between gap-4 mb-10">
          <h1 className="text-4xl leading-tight font-extrabold">{title}</h1>
          <Link
            to="/#contact-info"
            className="px-5 py-3 rounded-full bg-white text-black font-bold"
          >
            {t("home.cta_contact")}
          </Link>
        </div>

        {items.length === 0 ? (
          <p className="text-muted">{emptyText}</p>
        ) : (
          <div className="flex flex-col gap-10">
            {items.map((s, idx) => {
              const reverse = idx % 2 === 1;
              return (
                <div
                  key={idx}
                  className="rounded-2xl border border-neutral-800 p-6 hover:border-neutral-600 transition"
                >
                  <div
                    className={`grid grid-cols-1 md:grid-cols-2 gap-8 items-center ${
                      reverse ? "md:[&>*:first-child]:order-2" : ""
                    }`}
                  >
                    <div className="w-full">
                      {s.logo ? (
                        <figure className="w-full overflow-hidden rounded-2xl border border-neutral-800 shadow-sm">
                          <img
                            src={s.logo}
                            alt={s.name}
                            className="w-full h-56 sm:h-64 lg:h-80 object-cover"
                            loading="lazy"
                            decoding="async"
                            sizes="(min-width: 1024px) 32rem, (min-width: 640px) 28rem, 100vw"
                          />
                        </figure>
                      ) : (
                        <div className="w-full h-56 sm:h-64 lg:h-80 rounded-2xl border border-neutral-800 bg-neutral-900" />
                      )}
                    </div>

                    <div>
                      <h3 className="text-2xl font-bold mb-3">{s.name}</h3>
                      <p className="text-base text-muted">{s.blurb}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
